/**
 * Modal-opener helpers used by useUserManagement.
 *
 * Extracted from useUserManagement (Sub-PR 6.3).
 */

import type { User } from '../../types'
import type { CreateUserForm } from './types'

interface OpenerDeps {
  setSelectedUser: (user: User | null) => void
  setFormData: (data: CreateUserForm) => void
  setShowEditModal: (v: boolean) => void
  setShowDeleteModal: (v: boolean) => void
  setShowResetPasswordModal: (v: boolean) => void
  setActionMenuUser: (id: string | null) => void
}

interface ModalOpeners {
  openEditModal: (user: User) => void
  openDeleteModal: (user: User) => void
  openResetPasswordModal: (user: User) => void
}

export function useModalOpeners(deps: OpenerDeps): ModalOpeners {
  const openEditModal = (user: User): void => {
    deps.setSelectedUser(user)
    deps.setFormData({
      email: user.email,
      username: user.username,
      displayName: user.displayName ?? '',
      role: user.role,
      organisationId: user.organisationId ?? '',
    })
    deps.setShowEditModal(true)
    deps.setActionMenuUser(null)
  }

  const openDeleteModal = (user: User): void => {
    deps.setSelectedUser(user)
    deps.setShowDeleteModal(true)
    deps.setActionMenuUser(null)
  }

  const openResetPasswordModal = (user: User): void => {
    deps.setSelectedUser(user)
    deps.setShowResetPasswordModal(true)
    deps.setActionMenuUser(null)
  }

  return { openEditModal, openDeleteModal, openResetPasswordModal }
}
